import { useState, useEffect, ReactNode } from 'react';

interface DeferredLoaderProps {
  children: ReactNode;
  delay?: number;
}

/**
 * Defers rendering of children until after initial paint
 * Uses requestIdleCallback for optimal scheduling
 */
const DeferredLoader = ({ children, delay = 0 }: DeferredLoaderProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // Use requestIdleCallback if available, otherwise setTimeout
    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(() => {
        if (delay > 0) {
          setTimeout(() => setShouldRender(true), delay);
        } else {
          setShouldRender(true);
        }
      });
      return () => cancelIdleCallback(id);
    } else {
      const timeout = setTimeout(() => setShouldRender(true), delay || 100);
      return () => clearTimeout(timeout);
    }
  }, [delay]);

  if (!shouldRender) return null;

  return <>{children}</>;
};

export default DeferredLoader;
